<template>
  <div id="app" :class="['route--' + $route.name]">
    <Loader :value="isLoading" :delay="0" theme="default" :class="{ 'app--loading': isLoading }">
      <template v-if="!isLoading" #default>
        <Layout>
          <router-view />
        </Layout>

        <Upsell />

        <TaskModal />
        <PricingModal />
        <Notification />
      </template>

      <template #loader="{ content }">
        <div>
          <img src="/api/client/logo-light" alt="Kvass" width="200px" />
        </div>
        <div class="elder-loader__loading-message">{{ content.messages.loading }}</div>
        <FontAwesomeIcon class="elder-loader__loading-icon" v-bind="content.icon" spin />
      </template>
    </Loader>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Intercom from '@/intercom'
import { PrefixObjectKeys } from '@/utils'

import Layout from '@/layouts/Default'
import Upsell from '@/components/Upsell'
import Notification from '@/components/Notification'

import TaskModal from '@/components/Task/Modal'
import PricingModal from '@/components/Pricing/Modal'

const LoadTerms = () => {
  const script = document.createElement('script')
  script.src = '/api/terms/script.js'
  script.setAttribute('type', 'text/javascript')

  document.body.appendChild(script)
}

export default {
  watch: {
    '$auth.isAuthenticated': {
      handler(val) {
        if (!val) return
        Intercom(this)
        LoadTerms()
      },
      immediate: true,
    },
  },
  metaInfo() {
    return {
      title: this.$t('loggingIn') + '...',
      titleTemplate: ['%s', this.vendor.name].filter(Boolean).join(' | '),
      bodyAttrs: {
        ...PrefixObjectKeys('route-param-', this.$route.params),
        ...PrefixObjectKeys('route-data-', this.customBodyAttrs),
        'route-name': this.$route.name,
        'route-path': this.$route.path,
      },
    }
  },
  computed: {
    ...mapState(['vendor', 'user', 'intercomAppId', 'initialLoad']),
    isLoading() {
      return this.$path('loading', this.$auth)
    },
    customBodyAttrs() {
      if (!this.$route.meta) return {}
      return Object.fromEntries(
        Object.entries(this.$route.meta.bodyAttrs || {}).map(([k, p]) => [k, this.$path(p, this.$store.state)]),
      )
    },
  },
  mounted() {
    document.body.classList.remove('initializing')
  },
  components: {
    Layout,
    Upsell,
    TaskModal,
    PricingModal,
    Notification,
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  & > .elder-loader {
    transition: background-color 200ms ease;

    & > .elder-loader__element {
      .elder-loader__loading-message {
        display: none;
      }

      .elder-loader__element-content-inner {
        display: flex;
        gap: 1.5rem;
        flex-direction: column;
        align-items: center;

        svg {
          margin: 0;
          color: rgba(white, 0.2);
        }
      }
    }
  }

  .app--loading {
    background-color: hsl(var(--primary-h), var(--primary-s), 7%);
    z-index: 9;

    & > *:not(.elder-loader__element) {
      display: none;
    }
  }
}
</style>
